import {  useState, useRef } from 'react';

export default function useScroll( startScroll = 0 ) {

  const [paperGrow, setPaperGrow] = useState(false)
  const domRef = useRef();

  const onScroll = () => {
    const scrollTo = domRef.current.scrollTop;
    if(scrollTo > startScroll){
      setPaperGrow(true)
    }
    else if(scrollTo===0){
      setPaperGrow(false);
    }
  }

  return { domRef, paperGrow, onScroll }

}